/* eslint-disable vue/no-boolean-default */
<template>
  <div
    ref="leftBar"
    class="bg-light-pastel-purple flex h-full justify-center box-border w-64 xsm:w-3/5 sm:w-3/5 md:w-auto md:bg-pastel-purple min-h-[450px] md:relative fixed overflow-y-scroll left-0 top-0 md:z-[0] z-[5001] overflow-x-hidden pt-0 md:pl-0 rtl:ml-3.5 safe-area-top safe-area-bottom"
    :class="[leftBarVisibility ? 'md:col-span-3' : 'md:col-span-1 md:flex hidden']"
    @click="showLeftBar"
  >
    <div class="w-full h-full md:flex hidden absolute">
      <div
        class="absolute rounded-full xl:left-[-325px] lg:w-[590px] lg:left-[11px] md:w-[341px] md:bottom-[135px] md:left-[18px] h-[500px] w-[248px] bottom-[-9px] left-[8px] orange-circle"
      ></div>
    </div>

    <div
      :class="[
        leftBarVisibility
          ? 'col-span-3 md:bg-transparent tooltip'
          : 'col-span-1 md:bg-transparent ',
      ]"
      class="xl:px-5 px-2.5 h-[inherit] flex flex-col transform leftbar-margin-top w-full"
    >
      <div class="border-b-[1.5px] border-white pb-1 w-full" :style="headerHeightStyle">
        <div
          class="flex w-full xl:mt-[14px] mt-5 items-center mb-3 justify-between"
          :class="[(!leftBarVisibility || isTabView) && 'justify-center md:mb-6 mb-[15px]']"
        >
          <div class="flex items-center justify-between">
            <span class="flex items-center" :class="[leftBarVisibility && 'xl:pr-2 pr-1']">
              <div
                class="flex items-center justify-center"
                :class="[leftBarVisibility ? 'md:w-12 md:h-12 w-9 h-9 ' : 'w-9 h-9']"
              >
                <img v-if="logoUrl" :src="logoUrl" class="w-full h-full object-contain" />
                <icon v-else class="w-full h-full" icon="logoheader" />
              </div>
            </span>
            <div
              v-if="leftBarVisibility"
              :title="instituteTitle"
              class="relative group max-w-[170px]"
            >
              <p
                class="font-medium font-inter text-xs xl:text-sm text-gray-700 line-clamp-3 group-hover:invisible"
              >
                {{ instituteTitle }}
              </p>
              <div
                class="absolute top-0 left-0 hidden font-medium font-inter text-xs xl:text-sm text-gray-700 group-hover:block z-10 max-w-[170px]"
              >
                {{ instituteTitle }}
              </div>
            </div>
          </div>
          <div class="flex items-center">
            <span class="bg-white md:hidden block rounded-[5px] p-[5px]" @click="hideLeftBar">
              <icon icon="doubleChevronLeft" width="8" height="8" />
            </span>
          </div>
        </div>
      </div>
      <div class="flex flex-col divide-y divide-primary-white">
        <div
          class="items-center min-h-[50px] overflow-y-auto overflow-x-hidden"
          :class="[!leftBarVisibility && 'flex justify-center']"
          :style="contentWrapperStyle"
        >
          <!-- Left bar button -->
          <h1
            v-if="showLeftBarTitle"
            class="border-b border-primary-grey pb-1 font-roboto font-medium text-text-color px-2 mb-2"
          >
            <span>
              {{ $t(`leftBar.${leftBarContent.title}`) }}
            </span>
          </h1>
          <UiDropDown
            :left-bar-visibility="leftBarVisibility"
            :content="leftBarContent.routes"
            @setcurrentSelectedSection="setcurrentSelectedSection"
            @setSelectedCampuse="setSelectedCampuse"
          >
            <template v-slot:footer>
              <div
                v-if="!isPWARunning()"
                class="flex gap-1.5 md:gap-2 p-2 py-3 xl:py-4 items-center leading-[18px] text-sm font-medium text-primary-gray-700 cursor-pointer"
                @mouseover="profileActionMouseOver(5)"
                @mouseleave="profileActionMouseleave()"
              >
                <span class="h-6 w-6 flex items-center justify-center">
                  <icon
                    icon="installApp"
                    :color="profileActionIconColorClass(5)"
                    width="24"
                    height="24"
                  />
                </span>
                <span
                  v-if="leftBarVisibility"
                  v-i18n="header"
                  class="w-full"
                  :class="{ 'text-primary-purple-700': profileActionIconColor === 5 }"
                  @click="installPWA"
                >
                  Install App{{ profileActionIconColor }}
                </span>
              </div>
            </template>
          </UiDropDown>
        </div>

        <div ref="userConfiguration" class="divide-y divide-primary-white">
          <div class="flex flex-col" :class="[!leftBarVisibility && 'items-center']">
            <div class="p-2 py-3 xl:py-4">
              <span v-if="!leftBarVisibility">
                <icon icon="switchUsers" width="24" height="24" />
              </span>
              <UserRoleSwitch v-if="leftBarVisibility" class="w-full" />
            </div>
          </div>
          <div>
            <div class="py-[2px] w-full" :class="[!leftBarVisibility && 'flex justify-center']">
              <UserProfile />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { TENANT_ROLES } from '@src/constants/user-roles-constants.js'
import UserProfile from '@/src/modules/header/UserProfileSettings.vue'
import icon from '@components/icons/icon.vue'
import { UiDropDown } from '@components/UiElements'
import UserRoleSwitch from '@src/modules/header/UserRoleSwitch.vue'
import setPWA, { isPWARunning } from '@src/utils/pwa-utils.js'
import AuthMixins from '@src/mixins/auth-mixin.js'
import { getTimeInMs } from '@utils/generalUtil.js'
import { isCapacitor } from '@src/utils/platformUtil.js'
export default {
  components: {
    icon,
    UserProfile,
    UiDropDown,
    UserRoleSwitch,
  },
  mixins: [AuthMixins],

  props: {
    leftBarVisibility: { type: Boolean },
  },
  emits: ['handleClick'],
  data() {
    return {
      TENANT_ROLES,
      profileActionIconColor: null,

      get currentStudent() {
        return JSON.parse(localStorage.getItem('currentActiveStudent'))
      },
      set currentStudent(value) {
        JSON.parse(localStorage.getItem('currentActiveStudent'))
      },
      instituteName: JSON.parse(localStorage.getItem('setting'))?.title,
      rightBar: 'rightBar',
      header: 'header',
      userConfigurationHeight: 0,
      resizeObserver: null,
      userConfigResizeObserver: null,
      windowHeight: window.innerHeight,
    }
  },
  computed: {
    ...mapGetters('layout', ['instituteLogo']),
    ...mapState('settings', ['siteSettingLogoURL', 'generalSettingInstituteName']),
    ...mapState({
      activeStudent: (state) => state.student.activeStudent,
      isAssociatedStudentProfileActive: (state) => state.layout.isAssociatedStudentProfileActive,
      activeRole: (state) => state.layout.activeRole,
      leftBarContent: (state) => state.layout.leftBarContent,
      isTabView: (state) => state.layout.isTabView,
      showSectionDropdown: (state) => state.layout.showSectionDropdown,
      showClassDropdown: (state) => state.layout.showClassDropdown,
      headerOffSetHeight: (state) => state.layout.headerOffSetHeight,
    }),
    contentWrapperStyle() {
      return {
        height: `calc(${
          this.windowHeight - (this.userConfigurationHeight + this.headerOffSetHeight + 5)
        }px)`,
      }
    },
    isCapacitorApp() {
      return isCapacitor()
    },
    safeAreaTopInset() {
      if (!this.isCapacitorApp || typeof window === 'undefined') return 0
      const root = document.documentElement
      const cssValue =
        root?.style?.getPropertyValue('--safe-area-top') ||
        getComputedStyle(root).getPropertyValue('--safe-area-top')
      return parseFloat(cssValue) || 0
    },
    headerHeightStyle() {
      if (!this.headerOffSetHeight) return {}
      let minHeight = this.headerOffSetHeight
      if (this.isCapacitorApp) {
        minHeight = Math.max(minHeight - this.safeAreaTopInset - 28, 0)
      }
      return {
        minHeight: `${minHeight}px`,
      }
    },
    instituteTitle() {
      return this.generalSettingInstituteName || this.instituteName
    },
    logoUrl() {
      return this.siteSettingLogoURL || this.instituteLogo
    },
    showLeftBarTitle() {
      return (
        this.leftBarContent.title &&
        this.leftBarContent?.SHOW_SECTION_DROPDOWN_TO?.includes(this.activeRole)
      )
    },
  },
  watch: {
    leftBarVisibility() {
      this.$nextTick(() => {
        this.setUserConfigurationHeight()
      })
    },
    headerOffSetHeight() {
      this.$nextTick(() => {
        this.setUserConfigurationHeight()
      })
    },
  },
  page: {
    title: 'Campuses',
    meta: [{ name: 'description', content: 'Campuses' }],
  },
  mounted() {
    this.setLeftbarHeight()
    this.checkPWAInstallationOnLoad()
    this.setUserConfigurationHeight()
    this._resizeObserver = new ResizeObserver(() => {
      this.windowHeight = window.innerHeight
      this.setLeftbarHeight()
      this.setUserConfigurationHeight()
    })
    this._resizeObserver.observe(document.body)

    // Observe user configuration section for height changes
    this.userConfigResizeObserver = new ResizeObserver(() => {
      this.setUserConfigurationHeight()
    })
    if (this.$refs.userConfiguration) {
      this.userConfigResizeObserver.observe(this.$refs.userConfiguration)
    }
  },
  beforeUnmount() {
    if (this._resizeObserver) {
      this._resizeObserver.disconnect()
      this._resizeObserver = null
    }
    if (this.userConfigResizeObserver) {
      this.userConfigResizeObserver.disconnect()
      this.userConfigResizeObserver = null
    }
  },
  methods: {
    isPWARunning,
    profileActionMouseleave() {
      this.profileActionIconColor = null
    },
    profileActionMouseOver(index) {
      this.profileActionIconColor = index
    },
    installPWA() {
      setPWA()

      const promptEvent = window.deferredPrompt

      if (!promptEvent) {
        this.showPwaModal = true
        return
      }

      promptEvent.prompt()

      promptEvent.userChoice.then((choiceResult) => {
        window.deferredPrompt = null
        // Hard refresh after PWA installation
        if (choiceResult.outcome === 'accepted') {
          setTimeout(() => {
            window.location.reload(true)
          }, PWA_HARD_RELOAD_TIMEOUT)
        }
      })
    },
    profileActionIconColorClass(index) {
      return this.profileActionIconColor === index ? 'primary-purple-700' : 'primary-gray-700'
    },
    checkPWAInstallationOnLoad() {
      const nextCheck = localStorage.getItem('pwaNextCheck')
      const now = Date.now()
      const twentyFourHours = getTimeInMs(24, 'h')

      if (nextCheck && now < parseInt(nextCheck)) return

      localStorage.setItem('pwaNextCheck', (now + twentyFourHours).toString())

      if (!isPWARunning()) {
        this.installPWA()
      }
    },
    setLeftbarHeight() {
      let leftBar = this.$refs['leftBar']
      if (leftBar) {
        if (window.innerHeight < 450) {
          leftBar.style.overflowY = 'scroll'
          leftBar.style.height = window.innerHeight + 'px'
        } else {
          leftBar.style.height = '100%'
        }
      }
    },
    setUserConfigurationHeight() {
      if (this.$refs.userConfiguration) {
        this.userConfigurationHeight = this.$refs.userConfiguration.clientHeight
      }
    },
    showLeftBar() {
      if (!this.leftBarVisibility && !this.isTabView)
        this.$store.commit('layout/SET_TAB_LEFT_BAR', true)
    },
    hideLeftBar() {
      this.$store.commit('layout/SET_TAB_LEFT_BAR', false)
    },
    ...mapActions('layout', ['setcurrentSelectedSection']),
    ...mapActions('teacher', ['setSelectedCampuse']),
  },
}
</script>

<style lang="scss" scoped>
.orange-circle {
  background-image: radial-gradient(
    ellipse,
    rgba(255, 222, 188, 0.95),
    rgba(255, 148, 33, 0),
    transparent 140%
  );
}
::-webkit-scrollbar {
  display: none;
}
@media (min-width: 1025px) and (max-width: 1279px) {
  .leftbar-margin-top {
    margin-top: 0;
  }
}
</style>
